// Currency helpers shared between restaurants and delivery companies.
//
// Conventions (see ticket #223636):
//  - Restaurants keep their currency in `settings.price`   (e.g. "KM" / "EUR" / "DIN")
//  - Delivery companies keep their currency in `settings.currency`
//
// Business rule: a delivery company and every restaurant it cooperates with
// should use the same currency. It is not enforced on the backend, so the
// frontend warns the user before a mismatched cooperation is enabled.

export const CURRENCY_OPTIONS = [
  { text: "KM", val: "KM" },
  { text: "EUR", val: "EUR" },
  { text: "DIN", val: "DIN" },
];

// `settings` may arrive as a JSON string, an object or null - always hand back an object.
export function parseSettings(settings) {
  if (!settings) return {};
  if (typeof settings === "string") {
    try {
      return JSON.parse(settings) || {};
    } catch (e) {
      return {};
    }
  }
  return typeof settings === "object" ? settings : {};
}

export function getRestaurantCurrency(restaurant) {
  return parseSettings(restaurant && restaurant.settings).price || null;
}

export function getDeliveryCompanyCurrency(company) {
  return parseSettings(company && company.settings).currency || null;
}

// True only when both sides declare a currency and the two differ.
export function hasCurrencyMismatch(restaurant, company) {
  const restaurantCurrency = getRestaurantCurrency(restaurant);
  const companyCurrency = getDeliveryCompanyCurrency(company);
  if (!restaurantCurrency || !companyCurrency) return false;
  return restaurantCurrency !== companyCurrency;
}
